module.exports = __webpack_public_path__ + "img/new3.73e512c8.png";